import { createSelector } from '@reduxjs/toolkit';

import { LayoutModel } from '@paragon/contract-library';
import { ReadonlyRecord } from '@paragon/utilities';

import { getLayoutModelsWithPendingChanges } from './changeTracker';

export const getLayoutModels = createSelector(
  getLayoutModelsWithPendingChanges,
  (models: ReadonlyRecord<string, LayoutModel>) => Object.values(models) as readonly LayoutModel[],
);
